import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-editor.vue?vue&type=style&index=0&id=c67aa384&scoped=true&lang=scss"
import "./message-input-editor.vue?vue&type=style&index=1&id=c67aa384&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c67aa384"]])

export default __exports__